module.exports = __webpack_public_path__ + "static/media/complete-setup-illustration.6507c1c0.svg";